function reversedArray(array) {
  return array.slice(0).reverse();
}

module.exports = reversedArray;



/** WEBPACK FOOTER **
 ** ./~/react-router/modules/utils/reversedArray.js
 **/